import { RegionId, TmRegionResponse } from '@business/entities/tm/TmRegionResponse';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { RegionFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/AddEditRegionModal/RegionForm';
import { CategoryId } from '@business/entities/tm';
import { CategoryRegionProviderPriorityForm } from '@modules/settings/SettingsPage/Components/BillingTab/Tabs/CategoryTab/ManageProviderPriorityOverlay/ManageProviderPriorityOverlay';

export function fetchRegions() {
  return Endpoint.get<TmRegionResponse[]>(`@gc/regions`);
}

export function fetchRegionsMap() {
  return Endpoint.get<TmRegionResponse[]>(`@gc/regions/map`);
}

export function fetchRegion(id: RegionId) {
  return Endpoint.get<TmRegionResponse>(`@gc/regions/region/${id}`);
}

export function createRegion(data: RegionFormData) {
  return Endpoint.post<TmRegionResponse>(`@gc/regions`, { data });
}

export function updateRegion(id: RegionId, data: RegionFormData) {
  return Endpoint.patch<TmRegionResponse>(`@gc/regions/${id}`, { data });
}

export function deleteRegion(id: RegionId) {
  return Endpoint.delete<void>(`@gc/regions/${id}`);
}

export function fetchCategoryServiceProviders(categoryId: CategoryId) {
  return Endpoint.get<TmRegionResponse[]>(`@gc/regions/by-category/${categoryId}`);
}

export function saveProviderPriorities(data: CategoryRegionProviderPriorityForm) {
  return Endpoint.post<void>(`@gc/regions/update-priorities`, { data });
}
